import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_SETORES = 'LOAD_SETORES'
export const INATIVAR_SETOR = 'INATIVAR_SETOR'
export const REMOVER_INDEX = 'REMOVER_INDEX'
export const RESET_STATE = 'RESET_STATE'
export const EDIT_SETOR = 'EDIT_SETOR'
export const DELETE_SETOR = 'DELETE_SETOR'
export const BOOTSTRAP_SETOR_RELATORIO = 'BOOTSTRAP_SETOR_RELATORIO'

const getDefaultState = () => {
  return {
    getField,
    setores: null,
    loading: true,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [REMOVER_INDEX] (state, { index }) {
    state.setores.splice(index, 1)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_SETORES] ({ commit, state }) {
    commit(SET_STATE, { loading: true })
    await api.listEntidade('setor').then(
      setores => {
        commit(SET_STATE, { setores, loading: false })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    await dispatch(LOAD_SETORES)
  },
  async [INATIVAR_SETOR] ({ dispatch, commit, state }, setor) {
    const index = state.setores.findIndex(c => c.id === setor.id)

    Swal.fire({
      title: 'Excluir',
      text: 'Tem certeza que deseja excluir o Setor?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('setor', setor.id).then(
          result => result,
          ({
            error = null,
            message = 'Não foi possivel excluir o Setor!',
          }) => {
            Swal.fire({
              icon: 'error',
              title: error === null ? 'Ocorreu algum erro!' : 'Erro!',
              text: message,
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'O Setor foi excluído com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        commit(REMOVER_INDEX, { index })
        dispatch(BOOTSTRAP)
      }
    })
  },
  async [BOOTSTRAP_SETOR_RELATORIO] ({ dispatch, commit, state }) {
    await dispatch(LOAD_SETORES)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
